import React from 'react';
import { FadeIn } from './FadeIn';
import { TrustBadges } from './TrustBadges';
import { ChevronRightIcon, CheckCircle2Icon } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-16 sm:py-24 px-4 bg-pump-surface relative" data-id="element-141">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-pump-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-142" />

      <div className="max-w-xl mx-auto relative z-10" data-id="element-143">
        <FadeIn delay={0.1} data-id="element-144">
          <div className="bg-gradient-to-b from-pump-surfaceHover to-pump-dark border-2 border-pump-gold p-8 sm:p-10 rounded-3xl flex flex-col relative shadow-[0_0_60px_rgba(245,200,66,0.15)]" data-id="element-145">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-pump-gold text-pump-dark font-bold px-5 py-1.5 rounded-full text-sm uppercase tracking-wider shadow-[0_0_20px_rgba(245,200,66,0.4)]" data-id="element-146">
              Precio de lanzamiento
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-147">
              <span className="text-4xl mb-3 block" data-id="element-148">🎤</span>
              <h3 className="text-2xl sm:text-3xl font-display font-bold text-white mb-2" data-id="element-149">
                EL PROTOCOLO DEL INSTRUCTOR INOLVIDABLE
              </h3>
              <p className="text-gray-400" data-id="element-150">
                El sistema completo para instructores que quieren llenar su
                sala, dominar el escenario y construir una carrera que dure.
              </p>
            </div>

            <ul className="space-y-3 mb-8 max-w-sm mx-auto w-full" data-id="element-151">
              {['Tomo 1 — La Psicología del Escenario', 'Tomo 2 — Cueing de Conexión Emocional', 'Tomo 3 — El Guion Perfecto', 'Tomo 4 — Diseño de Atmósfera', 'Tomo 5 — Fidelización Post-Clase', 'Tomo 6 — Marketing de Sala', 'Bono 1 — Guía Rápida: ¿Qué Hacer Primero?', 'Bono 2 — Diccionario de Metáforas y Frases de Poder', 'Bono 3 — Scripts de Storytelling', 'Bono 4 — Guía de Nutrición y Autocuidado', 'Bono 5 — Checklists Zero Stress', 'Acceso inmediato y descarga permanente'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white font-medium" data-id="element-152">
                  <CheckCircle2Icon className="w-5 h-5 text-pump-gold shrink-0" data-id="element-153" />
                  <span data-id="element-154">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-8" data-id="element-155">
              <p className="text-gray-400 text-sm mb-3" data-id="element-156">
                Precio de lanzamiento:
              </p>
              <div className="text-5xl sm:text-6xl font-display font-black text-pump-gold drop-shadow-[0_0_20px_rgba(245,200,66,0.4)]" data-id="element-157">
                $19.999
              </div>
              <p className="text-gray-500 text-sm mt-2" data-id="element-158">
                Acceso inmediato — Descarga permanente
              </p>
            </div>

            <a href="https://protocolo-instructor-inolvidable.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="w-full bg-pump-gold hover:bg-pump-goldHover text-pump-dark font-display rounded-xl px-6 py-4 flex flex-col items-center justify-center transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_30px_rgba(245,200,66,0.25)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pump-gold" data-id="element-159">
              <span className="flex items-center gap-2 font-black text-xl leading-none" data-id="element-160">
                QUIERO EL PROTOCOLO AHORA
                <ChevronRightIcon className="w-6 h-6" strokeWidth={3} data-id="element-161" />
              </span>
              <span className="font-bold text-sm text-pump-dark/70 mt-1" data-id="element-162">
                $19.999 — Acceso inmediato
              </span>
            </a>

            <div className="mt-8" data-id="element-163">
              <TrustBadges data-id="element-164" />
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}